import { Autocomplete, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Paper, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import CommonGridHeader, { CommonDeleteButton, CommonEditButton } from '../../../Components/Common Components/CommonComponents';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { CurrencySymbol } from '../../../Utility/Constants';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import Loader from "../../../Components/Loader";
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions';


function MemberShipPackageConfig(props) {
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [editId, setEditID] = useState(null);
    const [formState, setFormState] = useState({
        PackageList: [],
        packageName: '',
        packagePrice: 0,
        VisitCount: 0,
        MemberCount: 0,
        DurationCount: 0,
        DurationUnit: "Months",
        AllServicesList: [],
        selectedOPServices: [],
        selectedIPServices: [],
        selectedLabServices: [],
        selectedRadServices: [],
        selectedOPHeadService: null,
        selectedOPServiceName: null,
        selectedIPHeadService: null,
        selectedIPServiceName: null,
        selectedLabHeadService: null,
        selectedLabServiceName: null,
        selectedRadHeadService: null,
        selectedRadServiceName: null,
        isOpPatient: false,
        opPercentage: 0,
        isIpPatient: false,
        ipPercentage: 0,
        islabPatient: false,
        labPercentage: 0,
        isPharmaPatient: false,
        PharmaPercentage: 0,
        isRadPatient: false,
        RadPercentage: 0,
        InvestPercentList: [],
        isOtPatient: false,
        OtPecentage: 0
    });

    useEffect(() => {
        getPackagesList()
        getModuleList()
    }, [])

    const errorMessage = (msg) => {
        setisloader(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setisloader(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const getPackagesList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.MEMBERSHIP_PACKAGE_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        let List = []
                        response.data.data?.forEach((element) => {
                            List.push({
                                ...element,
                                sno: List.length + 1,
                                duration_str: element?.duration + " " + element?.duration_mode,
                                percentages: (() => {
                                    let Percents = [];
                                    if (element?.discount_percentage_details) {
                                        const details = element.discount_percentage_details;
                                        if (details?.OP_details?.length) {
                                            const percent = details.OP_details[0]?.discount_percentage || 0;
                                            if (percent) Percents.push(`OP - ${percent}%`);
                                        }

                                        if (details?.IP_details?.length) {
                                            const percent = details.IP_details[0]?.discount_percentage || 0;
                                            if (percent) Percents.push(`IP - ${percent}%`);
                                        }

                                        if (Array.isArray(details?.Lab) && details.Lab.length > 0) {
                                            const percent = details.Lab[0]?.discount_percentage || 0;
                                            if (percent) Percents.push(`Lab - ${percent}%`);
                                        } else if (details?.Lab?.discount_percentage) {
                                            Percents.push(`Lab - ${details.Lab.discount_percentage}%`);
                                        }

                                        if (details?.Pharmacy?.discount_percentage) {
                                            Percents.push(`Pharmacy - ${details.Pharmacy.discount_percentage}%`);
                                        }

                                        if (Array.isArray(details?.Radiology) && details.Radiology.length > 0) {
                                            const percent = details.Radiology[0]?.discount_percentage || 0;
                                            if (percent) Percents.push(`Radiology - ${percent}%`);
                                        } else if (details?.Radiology?.discount_percentage) {
                                            Percents.push(`Radiology - ${details.Radiology.discount_percentage}%`);
                                        }

                                        if (details?.OT?.discount_percentage) {
                                            Percents.push(`OT - ${details.OT.discount_percentage}%`);
                                        }

                                        // dynamic keys (other than fixed ones) - investigations
                                        Object.keys(details).forEach((key) => {
                                            if (!["OP_details", "IP_details", "Lab", "Pharmacy", "Radiology", "OT"].includes(key)) {
                                                let percent = 0;
                                                if (Array.isArray(details[key])) {
                                                    percent = details[key]?.[0]?.discount_percentage || 0;
                                                } else {
                                                    percent = details[key]?.discount_percentage || 0;
                                                }

                                                if (percent) {
                                                    const label = key.replace("_details", ""); // clean name if needed
                                                    Percents.push(`${label} - ${percent}%`);
                                                }
                                            }
                                        });
                                    }

                                    return Percents;
                                })(),
                            });
                        })
                        setFormState((prev) => ({ ...prev, PackageList: List || [] }))
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getModuleList = () => {
        try {
            RestAPIService.getAll(Serviceurls.MODULE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || [];
                        setFormState((prev) => ({ ...prev, AllServicesList: ModuleData }));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };


    const renderPencentageInput = (fieldName, value, disable, fromInvestigation = false) => {
        return (
            <OutlinedInput
                size='small'
                name={fieldName}
                disabled={disable}
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                autoComplete='off'
                value={value || ''}
                sx={{ width: '10dvw', }}
                onChange={(e) => {
                    const { value } = e.target;
                    if (value === "" || (CommonValidation.DecimalNumber(value) && +value <= 100)) {
                        if (fromInvestigation) {
                            let InvestSelectedList = formState?.InvestPercentList || []
                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === fieldName)
                            if (index !== -1) {
                                InvestSelectedList[index].percentage = e.target.value
                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                            }
                        } else {
                            setFormState((prev) => ({ ...prev, [fieldName]: value }));
                        }
                    }
                }}
            />
        )
    }

    const renderOpServices = () => {
        return (
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingX: "1vw" }}>
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isOpPatient}
                        options={[...formState?.AllServicesList?.OP || [], ...formState?.AllServicesList?.IP_OP || []]}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.head_name}
                        value={formState?.selectedOPHeadService || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedOPHeadService: value, selectedOPServiceName: null }))
                        }}
                        renderInput={(params) => <TextField disabled={!formState?.isOpPatient} size='small' autoComplete='off' {...params} label={"Service Head"} />}
                    />
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isOpPatient}
                        options={formState?.selectedOPHeadService?.service_details || []}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.service_name}
                        value={formState?.selectedOPServiceName || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedOPServiceName: value }))
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!formState?.isOpPatient} autoComplete='off' {...params} label={"Service Name"} />}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: 2 }}>
                    <Button variant='outlined' size='small'
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            setFormState((prev) => ({
                                ...prev,
                                selectedOPHeadService: null,
                                selectedOPServiceName: null,
                            }))
                        }}
                    >Clear</Button>
                    <Button variant='outlined' size='small'
                        sx={{ marginLeft: "0.5vw", textTransform: 'capitalize' }}
                        disabled={!formState?.selectedOPHeadService}
                        onClick={() => {
                            let selectedServices = formState?.selectedOPServices || []
                            if (formState?.selectedOPServiceName) {
                                const isServiceExists = formState?.selectedOPServices.some(item => item.selected_service_details.some(service => service.id === formState?.selectedOPServiceName?.id));
                                if (isServiceExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: false,
                                        selected_service_details: [formState?.selectedOPServiceName],
                                        ...formState?.selectedOPHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedOPServices: [...selectedServices],
                                        selectedOPHeadService: null,
                                        selectedOPServiceName: null,
                                    }))
                                }
                            } else {
                                const isHeadExists = formState?.selectedOPHeadService?.service_details.some(valService =>
                                    formState?.selectedOPServices?.some(item =>
                                        item?.selected_service_details.some(service => service.id === valService.id)
                                    )
                                );
                                if (isHeadExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: true,
                                        selected_service_details: formState?.selectedOPHeadService?.service_details,
                                        ...formState?.selectedOPHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedOPServices: [...selectedServices],
                                        selectedOPHeadService: null,
                                        selectedOPServiceName: null,
                                    }))
                                }
                            }
                        }}
                    >Add Service</Button>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Service Head</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formState?.selectedOPServices?.map((item, index) => (
                                <TableRow key={`${index}}`}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item?.head_name}</TableCell>
                                    <TableCell>{item?.is_head ? "-" : item?.selected_service_details?.[0]?.service_name}</TableCell>
                                    <TableCell>
                                        <CommonDeleteButton onClick={() => {
                                            let selectedServices = formState?.selectedOPServices || []
                                            selectedServices.splice(index, 1)
                                            setFormState((prev) => ({ ...prev, selectedOPServices: [...selectedServices] }))
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }
    const renderIpServices = () => {
        return (
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingX: "1vw" }}>
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isIpPatient}
                        options={[...formState?.AllServicesList?.IP || [], ...formState?.AllServicesList?.IP_OP || []]}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.head_name}
                        value={formState?.selectedIPHeadService || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedIPHeadService: value, selectedIPServiceName: null }))
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!formState?.isIpPatient} autoComplete='off' {...params} label={"Service Head"} />}
                    />
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isIpPatient}
                        options={formState?.selectedIPHeadService?.service_details || []}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.service_name}
                        value={formState?.selectedIPServiceName || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedIPServiceName: value }))
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!formState?.isIpPatient} autoComplete='off' {...params} label={"Service Name"} />}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: 2 }}>
                    <Button variant='outlined' size='small'
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            setFormState((prev) => ({
                                ...prev,
                                selectedIPHeadService: null,
                                selectedIPServiceName: null,
                            }))
                        }}
                    >Clear</Button>
                    <Button variant='outlined' size='small'
                        sx={{ marginLeft: "0.5vw", textTransform: 'capitalize' }}
                        disabled={!formState?.selectedIPHeadService}
                        onClick={() => {
                            let selectedServices = formState?.selectedIPServices || []
                            if (formState?.selectedIPServiceName) {
                                const isServiceExists = formState?.selectedIPServices.some(item => item.selected_service_details.some(service => service.id === formState?.selectedIPServiceName?.id));
                                if (isServiceExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: false,
                                        selected_service_details: [formState?.selectedIPServiceName],
                                        ...formState?.selectedIPHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedIPServices: [...selectedServices],
                                        selectedIPHeadService: null,
                                        selectedIPServiceName: null,
                                    }))
                                }
                            } else {
                                const isHeadExists = formState?.selectedIPHeadService?.service_details.some(valService =>
                                    formState?.selectedIPServices?.some(item =>
                                        item?.selected_service_details.some(service => service.id === valService.id)
                                    )
                                );
                                if (isHeadExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: true,
                                        selected_service_details: formState?.selectedIPHeadService?.service_details,
                                        ...formState?.selectedIPHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedIPServices: [...selectedServices],
                                        selectedIPHeadService: null,
                                        selectedIPServiceName: null,
                                    }))
                                }
                            }
                        }}
                    >Add Service</Button>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Service Head</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formState?.selectedIPServices?.map((item, index) => (
                                <TableRow key={`${index}}`}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item?.head_name}</TableCell>
                                    <TableCell>{item?.is_head ? "-" : item?.selected_service_details?.[0]?.service_name}</TableCell>
                                    <TableCell>
                                        <CommonDeleteButton onClick={() => {
                                            let selectedServices = formState?.selectedIPServices || []
                                            selectedServices.splice(index, 1)
                                            setFormState((prev) => ({ ...prev, selectedIPServices: [...selectedServices] }))
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }

    const renderLabServices = () => {
        return (
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingX: "1vw" }}>
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.islabPatient}
                        options={[...formState?.AllServicesList?.Lab || [], ...formState?.AllServicesList?.LAB || []]}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.head_name}
                        value={formState?.selectedLabHeadService || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedLabHeadService: value, selectedLabServiceName: null }))
                        }}
                        renderInput={(params) => <TextField disabled={!formState?.islabPatient} size='small' autoComplete='off' {...params} label={"Service Head"} />}
                    />
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.islabPatient}
                        options={formState?.selectedLabHeadService?.service_details || []}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.service_name}
                        value={formState?.selectedLabServiceName || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedLabServiceName: value }))
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!formState?.islabPatient} autoComplete='off' {...params} label={"Service Name"} />}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: 2 }}>
                    <Button variant='outlined' size='small'
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            setFormState((prev) => ({
                                ...prev,
                                selectedLabHeadService: null,
                                selectedLabServiceName: null,
                            }))
                        }}
                    >Clear</Button>
                    <Button variant='outlined' size='small'
                        sx={{ marginLeft: "0.5vw", textTransform: 'capitalize' }}
                        disabled={!formState?.selectedLabHeadService}
                        onClick={() => {
                            let selectedServices = formState?.selectedLabServices || []
                            if (formState?.selectedLabServiceName) {
                                const isServiceExists = formState?.selectedLabServices.some(item => item.selected_service_details.some(service => service.id === formState?.selectedLabServiceName?.id));
                                if (isServiceExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: false,
                                        selected_service_details: [formState?.selectedLabServiceName],
                                        ...formState?.selectedLabHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedLabServices: [...selectedServices],
                                        selectedLabHeadService: null,
                                        selectedLabServiceName: null,
                                    }))
                                }
                            } else {
                                const isHeadExists = formState?.selectedLabHeadService?.service_details.some(valService =>
                                    formState?.selectedLabServices?.some(item =>
                                        item?.selected_service_details.some(service => service.id === valService.id)
                                    )
                                );
                                if (isHeadExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: true,
                                        selected_service_details: formState?.selectedLabHeadService?.service_details,
                                        ...formState?.selectedLabHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedLabServices: [...selectedServices],
                                        selectedLabHeadService: null,
                                        selectedLabServiceName: null,
                                    }))
                                }
                            }
                        }}
                    >Add Service</Button>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Service Head</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formState?.selectedLabServices?.map((item, index) => (
                                <TableRow key={`${index}}`}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item?.head_name}</TableCell>
                                    <TableCell>{item?.is_head ? "-" : item?.selected_service_details?.[0]?.service_name}</TableCell>
                                    <TableCell>
                                        <CommonDeleteButton onClick={() => {
                                            let selectedServices = formState?.selectedLabServices || []
                                            selectedServices.splice(index, 1)
                                            setFormState((prev) => ({ ...prev, selectedLabServices: [...selectedServices] }))
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }

    const renderRadServices = () => {
        return (
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingX: "1vw" }}>
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isRadPatient}
                        options={[...formState?.AllServicesList?.Radiology || [], ...formState?.AllServicesList?.RADIOLOGY || []]}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.head_name}
                        value={formState?.selectedRadHeadService || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedRadHeadService: value, selectedRadServiceName: null }))
                        }}
                        renderInput={(params) => <TextField disabled={!formState?.isRadPatient} size='small' autoComplete='off' {...params} label={"Service Head"} />}
                    />
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!formState?.isRadPatient}
                        options={formState?.selectedRadHeadService?.service_details || []}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.service_name}
                        value={formState?.selectedRadServiceName || null}
                        onChange={(e, value) => {
                            setFormState((prev) => ({ ...prev, selectedRadServiceName: value }))
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!formState?.isRadPatient} autoComplete='off' {...params} label={"Service Name"} />}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: 2 }}>
                    <Button variant='outlined' size='small'
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            setFormState((prev) => ({
                                ...prev,
                                selectedRadHeadService: null,
                                selectedRadServiceName: null,
                            }))
                        }}
                    >Clear</Button>
                    <Button variant='outlined' size='small'
                        sx={{ marginLeft: "0.5vw", textTransform: 'capitalize' }}
                        disabled={!formState?.selectedRadHeadService}
                        onClick={() => {
                            let selectedServices = formState?.selectedRadServices || []
                            if (formState?.selectedRadServiceName) {
                                const isServiceExists = formState?.selectedRadServices.some(item => item.selected_service_details.some(service => service.id === formState?.selectedRadServiceName?.id));
                                if (isServiceExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: false,
                                        selected_service_details: [formState?.selectedRadServiceName],
                                        ...formState?.selectedRadHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedRadServices: [...selectedServices],
                                        selectedRadHeadService: null,
                                        selectedRadServiceName: null,
                                    }))
                                }
                            } else {
                                const isHeadExists = formState?.selectedRadHeadService?.service_details.some(valService =>
                                    formState?.selectedRadServices?.some(item =>
                                        item?.selected_service_details.some(service => service.id === valService.id)
                                    )
                                );
                                if (isHeadExists) {
                                    errorMessage("This service is already added.");
                                } else {
                                    selectedServices.push({
                                        is_head: true,
                                        selected_service_details: formState?.selectedRadHeadService?.service_details,
                                        ...formState?.selectedRadHeadService
                                    })
                                    setFormState((prev) => ({
                                        ...prev,
                                        selectedRadServices: [...selectedServices],
                                        selectedRadHeadService: null,
                                        selectedRadServiceName: null,
                                    }))
                                }
                            }
                        }}
                    >Add Service</Button>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Service Head</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formState?.selectedRadServices?.map((item, index) => (
                                <TableRow key={`${index}}`}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item?.head_name}</TableCell>
                                    <TableCell>{item?.is_head ? "-" : item?.selected_service_details?.[0]?.service_name}</TableCell>
                                    <TableCell>
                                        <CommonDeleteButton onClick={() => {
                                            let selectedServices = formState?.selectedRadServices || []
                                            selectedServices.splice(index, 1)
                                            setFormState((prev) => ({ ...prev, selectedRadServices: [...selectedServices] }))
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }

    const renderInvestigationServices = (investigationName) => {
        const investItem = formState?.InvestPercentList?.find(list => list?.Investigation_name === investigationName);
        const isEnabled = !!investItem;
        const selectedServices = investItem?.selectedServices || [];
        const serviceList = formState?.AllServicesList?.[investigationName] || [];

        if (serviceList.length === 0) {
            return null; // No services available for this investigation
        }

        return (
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingX: "1vw" }}>
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!isEnabled}
                        options={serviceList}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.head_name}
                        value={investItem?.selectedInvestHeadService || null}
                        onChange={(e, value) => {
                            let InvestSelectedList = formState?.InvestPercentList || []
                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === investigationName)
                            if (index !== -1) {
                                InvestSelectedList[index].selectedInvestHeadService = value
                                InvestSelectedList[index].selectedInvestServiceName = null
                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                            }
                        }}
                        renderInput={(params) => <TextField disabled={!isEnabled} size='small' autoComplete='off' {...params} label={"Service Head"} />}
                    />
                    <Autocomplete
                        clearIcon
                        size='small'
                        sx={{ width: "15vw" }}
                        disabled={!isEnabled}
                        options={investItem?.selectedInvestHeadService?.service_details || []}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.service_name}
                        value={investItem?.selectedInvestServiceName || null}
                        onChange={(e, value) => {
                            let InvestSelectedList = formState?.InvestPercentList || []
                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === investigationName)
                            if (index !== -1) {
                                InvestSelectedList[index].selectedInvestServiceName = value
                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                            }
                        }}
                        renderInput={(params) => <TextField size='small' disabled={!isEnabled} autoComplete='off' {...params} label={"Service Name"} />}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: 2 }}>
                    <Button variant='outlined' size='small'
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            let InvestSelectedList = formState?.InvestPercentList || []
                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === investigationName)
                            if (index !== -1) {
                                InvestSelectedList[index].selectedInvestHeadService = null
                                InvestSelectedList[index].selectedInvestServiceName = null
                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                            }
                        }}
                    >Clear</Button>
                    <Button variant='outlined' size='small'
                        sx={{ marginLeft: "0.5vw", textTransform: 'capitalize' }}
                        disabled={!investItem?.selectedInvestHeadService}
                        onClick={() => {
                            let InvestSelectedList = formState?.InvestPercentList || []
                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === investigationName)
                            if (index !== -1) {
                                let selectedServices = InvestSelectedList[index].selectedServices || []
                                if (InvestSelectedList[index].selectedInvestServiceName) {
                                    const isServiceExists = selectedServices.some(item => item.selected_service_details.some(service => service.id === InvestSelectedList[index].selectedInvestServiceName?.id));
                                    if (isServiceExists) {
                                        errorMessage("This service is already added.");
                                    } else {
                                        selectedServices.push({
                                            is_head: false,
                                            selected_service_details: [InvestSelectedList[index].selectedInvestServiceName],
                                            ...InvestSelectedList[index].selectedInvestHeadService
                                        })
                                        InvestSelectedList[index].selectedServices = [...selectedServices]
                                        InvestSelectedList[index].selectedInvestHeadService = null
                                        InvestSelectedList[index].selectedInvestServiceName = null
                                        setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                                    }
                                } else {
                                    const isHeadExists = InvestSelectedList[index].selectedInvestHeadService?.service_details.some(valService =>
                                        selectedServices.some(item =>
                                            item?.selected_service_details.some(service => service.id === valService.id)
                                        )
                                    );
                                    if (isHeadExists) {
                                        errorMessage("This service is already added.");
                                    } else {
                                        selectedServices.push({
                                            is_head: true,
                                            selected_service_details: InvestSelectedList[index].selectedInvestHeadService?.service_details,
                                            ...InvestSelectedList[index].selectedInvestHeadService
                                        })
                                        InvestSelectedList[index].selectedServices = [...selectedServices]
                                        InvestSelectedList[index].selectedInvestHeadService = null
                                        InvestSelectedList[index].selectedInvestServiceName = null
                                        setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                                    }
                                }
                            }
                        }}
                    >Add Service</Button>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Service Head</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedServices?.map((item, idx) => (
                                <TableRow key={`${idx}}`}>
                                    <TableCell>{idx + 1}</TableCell>
                                    <TableCell>{item?.head_name}</TableCell>
                                    <TableCell>{item?.is_head ? "-" : item?.selected_service_details?.[0]?.service_name}</TableCell>
                                    <TableCell>
                                        <CommonDeleteButton onClick={() => {
                                            let InvestSelectedList = formState?.InvestPercentList || []
                                            let index = InvestSelectedList?.findIndex(list => list?.Investigation_name === investigationName)
                                            if (index !== -1) {
                                                let selectedServices = InvestSelectedList[index].selectedServices || []
                                                selectedServices.splice(idx, 1)
                                                InvestSelectedList[index].selectedServices = [...selectedServices]
                                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                                            }
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }

    const renderDiscountDeatils = () => {
        try {
            let Object = {
                'OP_details': formState?.selectedOPServices?.map((list) => {
                    if (list?.is_head) {
                        return {
                            'service_head_id': list?.id,
                            'service_detail_id': null,
                            'discount_percentage': +formState?.opPercentage || 0
                        }
                    } else {
                        return {
                            'service_head_id': list?.id,
                            'service_detail_id': list?.selected_service_details?.[0]?.id || null,
                            'discount_percentage': +formState?.opPercentage || 0
                        }
                    }
                }),
                'IP_details': formState?.selectedIPServices?.map((list) => {
                    if (list?.is_head) {
                        return {
                            'service_head_id': list?.id,
                            'service_detail_id': null,
                            'discount_percentage': +formState?.ipPercentage || 0
                        }
                    } else {
                        return {
                            'service_head_id': list?.id,
                            'service_detail_id': list?.selected_service_details?.[0]?.id || null,
                            'discount_percentage': +formState?.ipPercentage || 0
                        }
                    }
                }),
                'Lab': {
                    'discount_percentage': +formState?.labPercentage || 0,
                    'service_list': formState?.selectedLabServices?.length > 0 ? formState?.selectedLabServices?.map((list) => {
                        if (list?.is_head) {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': null,
                                'discount_percentage': +formState?.labPercentage || 0
                            }
                        } else {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': list?.selected_service_details?.[0]?.id || null,
                                'discount_percentage': +formState?.labPercentage || 0
                            }
                        }
                    }) : []
                },
                'Radiology': {
                    'discount_percentage': +formState?.RadPercentage || 0,
                    'service_list': formState?.selectedRadServices?.length > 0 ? formState?.selectedRadServices?.map((list) => {
                        if (list?.is_head) {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': null,
                                'discount_percentage': +formState?.RadPercentage || 0
                            }
                        } else {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': list?.selected_service_details?.[0]?.id || null,
                                'discount_percentage': +formState?.RadPercentage || 0
                            }
                        }
                    }) : []
                },
                'Pharmacy': {
                    'discount_percentage': +formState?.PharmaPercentage || 0
                },
                'OT': {
                    'discount_percentage': +formState?.OtPecentage || 0
                },
            }
            formState?.InvestPercentList?.forEach((item) => {
                const investServices = formState?.AllServicesList?.[item?.Investigation_name] || [];
                Object[item?.Investigation_name] = {
                    'discount_percentage': +item?.percentage || 0,
                    'service_list': investServices.length > 0 && item?.selectedServices?.length > 0 ? item.selectedServices.map((list) => {
                        if (list?.is_head) {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': null,
                                'discount_percentage': +item?.percentage || 0
                            }
                        } else {
                            return {
                                'service_head_id': list?.id,
                                'service_detail_id': list?.selected_service_details?.[0]?.id || null,
                                'discount_percentage': +item?.percentage || 0
                            }
                        }
                    }) : []
                }
            })

            return Object
        }
        catch (e) {
            errorMessage(e?.message)
        }
    }

    const postPackageData = () => {
        try {
            setisloader(true)
            let states = formState
            let data = {
                'package_name': states?.packageName || '',
                'package_amount': +states?.packagePrice || 0,
                'no_of_revisits': +states?.VisitCount || 0,
                'duration': +states?.DurationCount || 0,
                'duration_mode': states?.DurationUnit || '',
                'no_of_members': +states?.MemberCount || 0,
                'discount_percentage_details': renderDiscountDeatils(),
            }
            if (editId) {
                data.membership_config_id = editId
            }
            RestAPIService.create(data, Serviceurls.MEMBERSHIP_PACKAGE_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        ClearFunction()
                        getPackagesList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        }
        catch (error) {
            errorMessage(error.message);
        }
    }

    const ClearFunction = () => {
        setFormState({
            ...formState,
            packageName: '',
            packagePrice: 0,
            VisitCount: 0,
            MemberCount: 0,
            DurationCount: 0,
            DurationUnit: "Months",
            selectedOPServices: [],
            selectedIPServices: [],
            selectedLabServices: [],
            selectedRadServices: [],
            selectedOPHeadService: null,
            selectedOPServiceName: null,
            selectedIPHeadService: null,
            selectedIPServiceName: null,
            selectedLabHeadService: null,
            selectedLabServiceName: null,
            selectedRadHeadService: null,
            selectedRadServiceName: null,
            isOpPatient: false,
            opPercentage: 0,
            isIpPatient: false,
            ipPercentage: 0,
            islabPatient: false,
            labPercentage: 0,
            isPharmaPatient: false,
            PharmaPercentage: 0,
            isRadPatient: false,
            RadPercentage: 0,
            InvestPercentList: [],
            OtPecentage: 0,
            isOtPatient: false
        })
    }

    const ClearPercentDetals = (key) => {
        switch (key) {
            case 'op': setFormState({
                ...formState,
                opPercentage: "",
                selectedOPServices: [],
                selectedOPHeadService: null,
                selectedOPServiceName: null,
            })
                break;
            case "ip": setFormState({
                ...formState,
                ipPercentage: "",
                selectedIPServices: [],
                selectedIPHeadService: null,
                selectedIPServiceName: null,
            })
                break;
            case "lab": setFormState({
                ...formState,
                labPercentage: "",
                selectedLabServices: [],
                selectedLabHeadService: null,
                selectedLabServiceName: null,
            })
                break;
            case "pharmacy": setFormState({ ...formState, PharmaPercentage: "" })
                break;
            case "radiology": setFormState({
                ...formState,
                RadPercentage: "",
                selectedRadServices: [],
                selectedRadHeadService: null,
                selectedRadServiceName: null,
            })
                break;
            case "ot": setFormState({ ...formState, OtPecentage: "" })
                break;
        }
    }

    const Validation = () => {
        if (formState?.packageName && formState?.packagePrice && formState?.VisitCount && formState?.MemberCount && formState?.DurationCount) {
            //API Call
            if (formState?.selectedOPServices?.length === 0 && formState?.selectedIPServices?.length === 0 && !formState?.islabPatient && !formState?.isPharmaPatient && !formState?.isRadPatient && !formState?.isOtPatient && formState?.InvestPercentList?.length === 0) {
                errorMessage("Please select atleast one module.");
                return;
            } else if (formState?.isOpPatient && (!formState?.opPercentage || +formState?.opPercentage === 0 || formState?.selectedOPServices?.length === 0)) {
                errorMessage("Please enter Out Patient discount percentage and add services.");
                return;
            } else if (formState?.isIpPatient && (!formState?.ipPercentage || +formState?.ipPercentage === 0 || formState?.selectedIPServices?.length === 0)) {
                errorMessage("Please enter In Patient discount percentage and add services.");
                return;
            } else if (formState?.islabPatient && (!formState?.labPercentage || +formState?.labPercentage === 0)) {
                errorMessage("Please enter laboratory discount percentage.");
                return;
            } else if (formState?.isRadPatient && (!formState?.RadPercentage || +formState?.RadPercentage === 0)) {
                errorMessage("Please enter radiology discount percentage.");
                return;
            } else if (formState?.isPharmaPatient && (!formState?.PharmaPercentage || +formState?.PharmaPercentage === 0)) {
                errorMessage("Please enter pharmacy discount percentage.");
                return;
            } else if (formState?.InvestPercentList?.some((list) => (!list?.percentage || +list?.percentage === 0))) {
                errorMessage(`Please enter ${formState?.InvestPercentList?.find((list) => (!list?.percentage || +list?.percentage === 0))?.Investigation_name} discount percentage.`);
                return;
            } else {
                postPackageData()
            }
        } else {
            if (!formState?.packageName) {
                errorMessage("Please enter package name.");
            } else if (!+formState?.packagePrice) {
                errorMessage("Please enter package amount.");
            } else if (!formState?.VisitCount) {
                errorMessage('Please enter no of visits.');
            } else if (!formState?.MemberCount) {
                errorMessage('Please enter maximum member count.');
            } else if (!formState?.DurationCount) {
                errorMessage('Please enter duration.');
            }
        }
    }
    formState?.PackageList?.forEach((element, index) => element.sno = index + 1)
    const columns = [
        { field: 'sno', headerName: "S No", flex: 0.05, align: "center", headerAlign: "center" },
        {
            field: "package_name", headerName: "Package Name", flex: 0.27,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.package_name ? params?.row?.package_name?.length > 30 ?
                <Tooltip placement='top' title={params?.row?.package_name} arrow><div>{params?.row?.package_name.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.package_name : "-"}</Box>)
        },
        {
            field: 'package_amount', headerName: 'Package Amount', flex: 0.15,
            renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.package_amount || 0)}</Box>)
        },
        {
            field: 'duration_str', headerName: 'Duration', flex: 0.1,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.duration_str || "-"}</Box>)
        },
        {
            field: 'percentages', headerName: 'Discount Details', flex: 0.15,
            renderCell: (params) => (<Box component={'div'}>
                <Tooltip title={
                    <div>
                        {params?.row?.percentages?.map((list) => (
                            <li>{list}</li>
                        ))}
                    </div>
                } arrow placement="bottom">
                    <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: Colors.ThemeColor }}>View Discount Details</Typography>
                </Tooltip>
            </Box>)
        },
        {
            field: "action", headerName: "Action", flex: 0.07, align: "center", headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}>
                <CommonEditButton disable={!props?.Access?.editAccess} onClick={() => {
                    let OpServices = params?.row?.discount_percentage_details?.OP_details?.map((item) => {
                        let HeadDetails = [...formState?.AllServicesList?.OP || [], ...formState?.AllServicesList?.IP_OP || []]?.find((list) => (list?.id === item.service_head_id))
                        return {
                            ...HeadDetails,
                            is_head: item.service_detail_id === null,
                            selected_service_details: item.service_detail_id
                                ? HeadDetails?.service_details?.filter((list) => (list?.id === item.service_detail_id))
                                : [],
                        }
                    })
                    let IpServices = params?.row?.discount_percentage_details?.IP_details?.map((item) => {
                        let HeadDetails = [...formState?.AllServicesList?.IP || [], ...formState?.AllServicesList?.IP_OP || []]?.find((list) => (list?.id === item.service_head_id))
                        return {
                            ...HeadDetails,
                            is_head: item.service_detail_id === null,
                            selected_service_details: item.service_detail_id
                                ? HeadDetails?.service_details?.filter((list) => (list?.id === item.service_detail_id))
                                : [],
                        }
                    })
                    let LabServices = Array.isArray(params?.row?.discount_percentage_details?.Lab?.service_list)
                        ? params?.row?.discount_percentage_details?.Lab?.service_list?.map((item) => {
                            let HeadDetails = [...formState?.AllServicesList?.Lab || [], ...formState?.AllServicesList?.LAB || []]?.find((list) => (list?.id === item.service_head_id))
                            return {
                                ...HeadDetails,
                                is_head: item.service_detail_id === null,
                                selected_service_details: item.service_detail_id
                                    ? HeadDetails?.service_details?.filter((list) => (list?.id === item.service_detail_id))
                                    : [],
                            }
                        })
                        : []
                    let RadServices = Array.isArray(params?.row?.discount_percentage_details?.Radiology?.service_list)
                        ? params?.row?.discount_percentage_details?.Radiology?.service_list?.map((item) => {
                            let HeadDetails = [...formState?.AllServicesList?.Radiology || [], ...formState?.AllServicesList?.RADIOLOGY || []]?.find((list) => (list?.id === item.service_head_id))
                            return {
                                ...HeadDetails,
                                is_head: item.service_detail_id === null,
                                selected_service_details: item.service_detail_id
                                    ? HeadDetails?.service_details?.filter((list) => (list?.id === item.service_detail_id))
                                    : [],
                            }
                        })
                        : []
                    setFormState({
                        ...formState,
                        packageName: params?.row?.package_name || "",
                        packagePrice: params?.row?.package_amount || "",
                        VisitCount: params?.row?.no_of_revisits || "",
                        MemberCount: params?.row?.no_of_members || "",
                        DurationCount: params?.row?.duration || "",
                        DurationUnit: params?.row?.duration_mode || "Months",
                        // Discount details
                        opPercentage: params?.row?.discount_percentage_details?.OP_details?.[0]?.discount_percentage || 0,
                        ipPercentage: params?.row?.discount_percentage_details?.IP_details?.[0]?.discount_percentage || 0,
                        labPercentage: Array.isArray(params?.row?.discount_percentage_details?.Lab)
                            ? params?.row?.discount_percentage_details?.Lab?.[0]?.discount_percentage || 0
                            : params?.row?.discount_percentage_details?.Lab?.discount_percentage || 0,
                        PharmaPercentage: params?.row?.discount_percentage_details?.Pharmacy?.discount_percentage || 0,
                        RadPercentage: Array.isArray(params?.row?.discount_percentage_details?.Radiology)
                            ? params?.row?.discount_percentage_details?.Radiology?.[0]?.discount_percentage || 0
                            : params?.row?.discount_percentage_details?.Radiology?.discount_percentage || 0,
                        OtPecentage: params?.row?.discount_percentage_details?.OT?.discount_percentage || 0,
                        // Checkboxes
                        isOpPatient: !!params?.row?.discount_percentage_details?.OP_details?.length,
                        isIpPatient: !!params?.row?.discount_percentage_details?.IP_details?.length,
                        islabPatient: (Array.isArray(params?.row?.discount_percentage_details?.Lab?.service_list) && params?.row?.discount_percentage_details?.Lab?.service_list?.length > 0)
                            || (params?.row?.discount_percentage_details?.Lab?.discount_percentage || 0),
                        isPharmaPatient: !!params?.row?.discount_percentage_details?.Pharmacy && (params?.row?.discount_percentage_details?.Pharmacy?.discount_percentage || 0),
                        isRadPatient: (Array.isArray(params?.row?.discount_percentage_details?.Radiology) && params?.row?.discount_percentage_details?.Radiology?.length > 0)
                            || (params?.row?.discount_percentage_details?.Radiology?.discount_percentage || 0),
                        isOtPatient: !!params?.row?.discount_percentage_details?.OT && (params?.row?.discount_percentage_details?.OT?.discount_percentage || 0),
                        // Service lists
                        selectedOPServices: OpServices || [],
                        selectedIPServices: IpServices || [],
                        selectedLabServices: LabServices || [],
                        selectedRadServices: RadServices || [],
                        selectedOPHeadService: null,
                        selectedOPServiceName: null,
                        selectedIPHeadService: null,
                        selectedIPServiceName: null,
                        selectedLabHeadService: null,
                        selectedLabServiceName: null,
                        selectedRadHeadService: null,
                        selectedRadServiceName: null,
                        // Investigation list
                        InvestPercentList: Object.entries(params?.row?.discount_percentage_details || {})
                            .filter(([key]) =>
                                !["OP_details", "IP_details", "Lab", "Radiology", "Pharmacy", "OT"].includes(key)
                            )
                            .map(([Investigation_name, val]) => ({
                                Investigation_name,
                                percentage: Array.isArray(val) ? (val[0]?.discount_percentage || 0) : (val.discount_percentage || 0),
                                selectedServices: Array.isArray(val?.service_list) ? val?.service_list?.map((item) => {
                                    const HeadDetails = formState?.AllServicesList?.[Investigation_name]?.find((list) => (list?.id === item.service_head_id))
                                    return {
                                        ...HeadDetails,
                                        is_head: item.service_detail_id === null,
                                        selected_service_details: item.service_detail_id
                                            ? HeadDetails?.service_details?.filter((list) => (list?.id === item.service_detail_id))
                                            : [],
                                    }
                                }) : [],
                            })),
                    });
                    setEditID(params.row.id);
                }} />
            </Box>)
        },
    ]
    let InvestgationList = localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : []
    return (
        <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
            <Grid container spacing={3} className="eMed_srvConfig_Box">
                <Grid item xs={7.6}>
                    <Paper className="eMed_srvConfig_Div" >
                        <DataGrid
                            rows={formState?.PackageList || []}
                            columns={columns}
                            getRowId={(row) => row.id}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            disableSelectionOnClick
                            components={{
                                Toolbar: CommonGridHeader.CommonToolBar,
                                NoRowsOverlay: () => {
                                    return (
                                        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                            {"No Records Found"}
                                        </Stack>
                                    )
                                }
                            }}
                            headerHeight={40}
                            rowCount={formState?.PackageList?.length}
                            onPageChange={(newPage) => { setpage(newPage) }}
                            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                            pageSize={pageSize}
                            rowsPerPageOptions={[10, 20, 30]}
                            pagination
                        />
                    </Paper>
                </Grid>
                <Grid item xs={4.4}>
                    <Paper className="eMed_srvConfig_Div">
                        <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                            <p className='eMed_srvConfig_rightHead_txt'>{"Membership Configuration"}</p>
                        </div>
                        <Box sx={{ height: "69dvh", overflowY: "auto", padding: "0.5vw" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between", padding: "0.5vw" }}>
                                <TextField
                                    size='small'
                                    name={"packageName"}
                                    autoComplete='off'
                                    value={formState?.packageName || ''}
                                    id="drug-master"
                                    sx={{ width: '30dvw', }}
                                    label={"Package Name *"}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        if (value === "" || value.length <= 100) {
                                            setFormState({
                                                ...formState,
                                                packageName: e.target.value
                                            });
                                        }
                                    }}
                                    variant="outlined"
                                />
                                <TextField
                                    size='small'
                                    name={"packageamt"}
                                    autoComplete='off'
                                    value={formState?.packagePrice || ''}
                                    id="drug-master"
                                    sx={{ width: '15dvw', marginTop: "0.5vw" }}
                                    label={"Package Amount *"}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        if (value === "" || (CommonValidation.numberOnly(value) && value <= 9999999)) {
                                            setFormState({
                                                ...formState,
                                                packagePrice: e.target.value
                                            });
                                        }
                                    }}
                                    placeholder={CurrencySymbol}
                                    variant="outlined"
                                />
                            </Box>
                            <Divider textAlign='left' sx={{ marginLeft: '0.5vw' }}>
                                <Typography sx={{ padding: "0.3vw", fontSize: '0.8vw', color: Colors?.grayShade }}>{"Membership Discount"}</Typography></Divider>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingX: 2 }}>
                                <Typography sx={{ textTransform: "uppercase", fontWeight: 600, fontSize: "0.9vw" }}>Module</Typography>
                                <Typography sx={{ textTransform: "uppercase", fontWeight: 600, fontSize: "0.9vw" }}>Disc Percentage %</Typography>
                            </Box>
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.isOpPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("op")
                                    }
                                    setFormState((prev) => ({ ...prev, isOpPatient: e.target.checked }))
                                }} />} label={`Out Patient`} />
                                {renderPencentageInput('opPercentage', formState?.opPercentage, !formState?.isOpPatient)}
                            </Box>
                            {renderOpServices()}
                            <Divider />
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.isIpPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("ip")
                                    }
                                    setFormState((prev) => ({ ...prev, isIpPatient: e.target.checked }))
                                }} />} label={`In Patient`} />
                                {renderPencentageInput('ipPercentage', formState?.ipPercentage, !formState?.isIpPatient)}
                            </Box>
                            {renderIpServices()}
                            <Divider />
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.islabPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("lab")
                                    }
                                    setFormState((prev) => ({ ...prev, islabPatient: e.target.checked }))
                                }} />} label={`Laboratory`} />
                                {renderPencentageInput('labPercentage', formState?.labPercentage, !formState?.islabPatient)}
                            </Box>
                            {renderLabServices()}
                            <Divider />
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.isRadPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("radiology")
                                    }
                                    setFormState((prev) => ({ ...prev, isRadPatient: e.target.checked }))
                                }} />} label={`Radiology`} />
                                {renderPencentageInput('RadPercentage', formState?.RadPercentage, !formState?.isRadPatient)}
                            </Box>
                            {renderRadServices()}
                            {
                                InvestgationList?.length &&
                                InvestgationList?.map((item, index) => (
                                    <Box key={`${index}}`}>
                                        <Divider />
                                        <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <FormControlLabel control={<Checkbox size='small' checked={formState?.InvestPercentList?.some(list => list?.Investigation_name === item)} onChange={(e) => {
                                                let InvestSelectedList = formState?.InvestPercentList || []
                                                if (e.target.checked) {
                                                    InvestSelectedList.push({
                                                        Investigation_name: item,
                                                        percentage: 0,
                                                        selectedServices: [],
                                                        selectedInvestHeadService: null,
                                                        selectedInvestServiceName: null
                                                    })
                                                } else {
                                                    InvestSelectedList = InvestSelectedList?.filter(list => list?.Investigation_name !== item)
                                                }
                                                setFormState((prev) => ({ ...prev, InvestPercentList: InvestSelectedList }))
                                            }} />} label={item} />
                                            {renderPencentageInput(item, (formState?.InvestPercentList?.find(list => list?.Investigation_name === item)?.percentage || ""), !formState?.InvestPercentList?.some(list => list?.Investigation_name === item), true)}
                                        </Box>
                                        {renderInvestigationServices(item)}
                                    </Box>
                                ))
                            }
                            <Divider />
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.isPharmaPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("pharmacy")
                                    }
                                    setFormState((prev) => ({ ...prev, isPharmaPatient: e.target.checked }))
                                }} />} label={`Pharmacy`} />
                                {renderPencentageInput('PharmaPercentage', formState?.PharmaPercentage, !formState?.isPharmaPatient)}
                            </Box>
                            <Divider />
                            <Box sx={{ padding: "0.5vw", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <FormControlLabel control={<Checkbox size='small' checked={formState?.isOtPatient} onChange={(e) => {
                                    if (!e.target.checked) {
                                        ClearPercentDetals("ot")
                                    }
                                    setFormState((prev) => ({ ...prev, isOtPatient: e.target.checked }))
                                }} />} label={`OT`} />
                                {renderPencentageInput('OtPecentage', formState?.OtPecentage, !formState?.isOtPatient)}
                            </Box>
                            <Divider />
                            <Box sx={{ marginTop: "2dvh", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <TextField
                                    size='small'
                                    name={"noOfVisits"}
                                    autoComplete='off'
                                    value={formState?.VisitCount || ''}
                                    sx={{ width: '12dvw', }}
                                    label={"No Of Visits *"}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 2)) {
                                            setFormState({
                                                ...formState,
                                                VisitCount: e.target.value
                                            })
                                        }
                                    }}
                                    variant="outlined"
                                />
                                <Box>
                                    <TextField
                                        size='small'
                                        name={"noOfVisits"}
                                        autoComplete='off'
                                        value={formState?.DurationCount || ''}
                                        sx={{ width: '10dvw', }}
                                        label={"Duration *"}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 2)) {
                                                setFormState({
                                                    ...formState,
                                                    DurationCount: e.target.value
                                                })
                                            }
                                        }}
                                        variant="outlined"
                                    />
                                    <FormControl size='small' sx={{ width: '7dvw' }}>
                                        <InputLabel>Period</InputLabel>
                                        <Select
                                            label='Period'
                                            value={formState?.DurationUnit || ""}
                                            onChange={(e) => {
                                                setFormState({
                                                    ...formState,
                                                    DurationUnit: e.target.value
                                                })
                                            }}
                                        >
                                            <MenuItem value={"Days"}>{"Days"}</MenuItem>
                                            <MenuItem value={"Months"}>{"Months"}</MenuItem>
                                            <MenuItem value={"Years"}>{"Years"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            <TextField
                                size='small'
                                name={"noOfVisits"}
                                autoComplete='off'
                                value={formState?.MemberCount || ''}
                                sx={{ width: '12dvw', marginTop: "1dvh" }}
                                label={"Max. Member Count *"}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 2)) {
                                        setFormState({
                                            ...formState,
                                            MemberCount: e.target.value
                                        })
                                    }
                                }}
                                variant="outlined"
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: "center", padding: 2 }}>
                                <Button variant='outlined' size='small' sx={{ textTransform: "capitalize" }} onClick={() => ClearFunction()}>Clear</Button>
                                <Button variant='contained' size='small' disabled={isloader || !props?.Access?.editAccess} sx={{ marginLeft: "1vw", textTransform: "capitalize" }} onClick={() => {
                                    setisloader(true)
                                    Validation()
                                }}>{editId ? "Update" : "Add"}</Button>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {console.log(formState)}
            {isloader ? <Loader loaderOpen={isloader} /> : null}
        </Box>
    )
}

export default MemberShipPackageConfig